import React, { FunctionComponent } from 'react';

import { Collapse } from '../../../atoms/Collapse';

import $Content from './AccordionContent.styles';

interface AccordionContentProps {
  naked: boolean;
  isOpen: boolean;
  componentThemeName?: string;
  isListTheme?: boolean;
  couldUnmountIfClosed?: boolean;
}

const AccordionContent: FunctionComponent<
  React.PropsWithChildren<AccordionContentProps>
> = ({
  children,
  naked,
  isOpen,
  componentThemeName,
  isListTheme = false,
  couldUnmountIfClosed,
}) => {
  return (
    <Collapse isOpen={isOpen} couldUnmountIfClosed={couldUnmountIfClosed}>
      <$Content
        $naked={naked}
        $componentThemeName={componentThemeName}
        $isList={isListTheme}
      >
        {children}
      </$Content>
    </Collapse>
  );
};

export default AccordionContent;
